import workspaceQuery from '../../../graphql/queries/sales/BigCommerceConfigurationWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/BigCommerceConfigurationListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/BigCommerceConfigurationQuery.graphql';
import defaultQuery from '../../../graphql/queries/sales/BigCommerceConfigurationDefault.graphql';
import mutationQuery from '../../../graphql/mutations/sales/BigCommerceConfigurationMutation.graphql';
import fragment from '../../../graphql/fragments/sales/BigCommerceConfigurationFragment.graphql';
import { ALLOW_ADD, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const BigCommerceConfiguration: EntityType = {
  type: 'BigCommerceConfiguration',
  title: 'BigCommerce Configurations',
  formTitle: 'BigCommerce Configuration',
  formUrl: '/Sales/Channel/BigCommerceConfig/Details/',
  workspaceUrl: '/Sales/Channel/BigCommerceConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'SALES_BIGCOMMERCE_CONFIG',
  operations: ALLOW_ADD | ALLOW_EDIT | ALLOW_VIEW,
};

export default BigCommerceConfiguration;
